'use strict';

angular.module('shiftTraderApp')
  .directive('saWorkingWithGrid', function () {
    return {
      templateUrl: 'views/directives/saWorkingWithGrid.html',
      restrict: 'EA',
      scope: {
        selectedUser: '=',
        me: '=',
        workPeriod: '='
      },
      controller: ['$scope', 'WorkPeriodStore', function($scope, WorkPeriodStore) {
        $scope.otherWorkPeriods = undefined;
        $scope.workPeriodsToDisplay = [];
        var maxNumberToDisplay = 5;

        WorkPeriodStore.getWorkPeriodsBetween(moment($scope.workPeriod.start_time).subtract(8, 'hours'), moment($scope.workPeriod.end_time).add(8, 'hours'))
          .then(function(workPeriods) {
            $scope.otherWorkPeriods = lodash.filter(workPeriods, function(wp) {
              return wp.$isAssigned() && wp.active && wp.$isPublished();
            });

            var temp = lodash.filter(lodash.map($scope.otherWorkPeriods, function(wp, idx) {
              // return false if it's your shift
              if ($scope.selectedUser && $scope.selectedUser.id) {
                if ($scope.selectedUser.id === wp.user.id) {
                  return false;
                }
              } else {
                if ($scope.me.id === wp.user.id) {
                  return false;
                }
              }

              if (wp.range_twix.overlaps($scope.workPeriod.range_twix) &&
                  Math.abs(wp.range_twix.intersection($scope.workPeriod.range_twix).length('minutes')) > 0) {
                return wp;
              } else {
                return false;
              }
            }), function(datum) {
              return datum !== false;
            });

            if (temp.length > 0) {
              temp = lodash.sortBy(temp, function(wp) {
                return -1 * Math.abs(wp.range_twix.intersection($scope.workPeriod.range_twix).length('minutes'));
              });
              if (temp.length <= maxNumberToDisplay) {
                $scope.workPeriodsToDisplay = temp;
              } else {
                $scope.workPeriodsToDisplay = temp.slice(0,maxNumberToDisplay);
              }
            } else {
              $scope.workPeriodsToDisplay = [];
            }
          });
      }]
    };
  });
